<template>
  <ScreenAdapter>
  <div class="drugs flex-column">
    <div class="drugs-top flex-row justify-between">
      <div class="drugs-top-left flex-row align-center">
        <img src="../assets/img/logo.png" alt="">
        <span style="font-weight:600">{{OrgName}}</span>
        <span>|</span>
        <span>取药大屏</span>
      </div>
      <div class="drugs-top-right flex-row align-center flex-shrink" id="times">
          {{timeMsg}}
          <img src="../assets/img/set-bl.png" alt="" @click="goSet">
      </div>
    </div>
    <div class="drugs-con flex-1 flex-row justify-between">
      <div class="drugs-con-common drugs-con-left flex-column" v-if="DataType == 3 || DataType == 1">
        <p class="con-common-name" style="background: #570404;">待配药</p>
        <ul class="con-common-ti flex-row align-center" style="background-color:#8e0404">
          <li>No</li>
          <li>顾客信息</li>
          <li>类别</li>
          <li>取药码</li>
        </ul>
        <div class="swiper-container flex-column" id="swiperLeft">
          <OrderList :list="adjusteList" types="py" />
        </div>
      </div>
      <div class="drugs-con-common drugs-con-right flex-column" v-if="DataType == 3 || DataType == 2">
        <p class="con-common-name" style="background: #0d4471;">待取药</p>
        <ul class="con-common-ti flex-row align-center" style="background-color:#146db6">
          <li :style="{'width':DataType==2?'260px':'110px'}">No</li>
          <li :style="{'width':DataType==2?'700px':'320px'}">顾客信息</li>
          <li :style="{'text-align':DataType==2?'center':'right'}">取药码</li>
        </ul>
        <div class="swiper-container flex-column" id="swiperRight">
          <OrderList :list="medicineList" types="qy" :DataType="DataType" />
        </div>
      </div>
    </div>
    <!-- <div class="drugs-footer flex-row align-center justify-between">
      <span>温馨提示：请依据队列提示信息，按号取药！祝您早日康复！</span>
      <span>圣者济世·爱心养生</span>
    </div> -->
  </div>
  </ScreenAdapter >
</template>

<script>
import ScreenAdapter from '../components/ScreenAdapter'
import OrderList from '../components/orderList'
import Swiper from 'swiper'
import Speech from 'speak-tts'
export default {
  components: {ScreenAdapter, OrderList},
  data () {
    return {
      timeMsg: '', // 时间
      speech: null, // 浏览器语音播报实例
      audioText: '', // 要播放的语音文字
      OrgCode: '', // 组织id
      OrgName: '', // 组织名称
      DataType: 3, // 区分要查询的内容，1待调剂，2待取药，3待调剂和待取药，默认为3全部配置
      DqySilder: 5, // 待取药默认5个
      CashType: '', // 分类
      adjusteList: [], // 待调剂
      medicineList: [], // 待取药
      audioPlayList: [], // 要播放的语音列表
      audioisPlayList: [], // 已经播放的语音列表
      timer: null, // 当前时间定时器
      getOrderTimer: null, // 获取订单定时器
      voiceEnd: true, // 语音是否播放完毕
      leftDataEnd: true, // 获取左边待调剂是否滚动完毕
      rightDataEnd: true, // 获取右边待取药是否滚动完毕
      audioList: [] // 处理后的播放语音列表
    }
  },
  mounted () {
    // eslint-disable-next-line no-unused-vars
    let parmas = this.$route.query
    // 路由参数中有组织，查询类别，查询种类参数
    if (JSON.stringify(parmas) !== '{}') {
      this.OrgCode = parmas.OrgCode // 组织id
      this.CashType = parmas.CashType // 处方类别
      this.OrgName = parmas.OrgName // 组织名称
      this.DataType = parmas.DataType || 3 // 查询种类
      this.DqySilder = this.DataType == 2 ? 8 : 5
    } else {
      let localData = JSON.parse(this.local.getItem('params')) // 获取本地缓存中的配置信息
      if (localData) {
        this.OrgCode = localData.OrgCode
        this.CashType = localData.CashType
        this.OrgName = localData.OrgName
        this.DataType = localData.DataType || 3
        this.DqySilder = this.DataType == 2 ? 8 : 5
      } else {
        this.goSet()
      }
    }
    this.getInitData(1)
    // 前端定时轮询查询订单数据，1500查询一次
    this.getOrderTimer = setInterval(() => {
      // console.log(this.leftDataEnd)
      // console.log(this.rightDataEnd)
      // 如果分页大于5条，分页完毕再去轮询
      if (this.DataType == 2) {
        if (this.rightDataEnd) { // 只查询待取药就不用判断待配药的数据是否加载完毕
          this.getInitData(0)
        }
      } else {
        if (this.leftDataEnd || this.rightDataEnd) {
          this.getInitData(0)
        }
      }
    }, 15000)
    this.initTime() // 初始化系统时间
    this.speechInit() // 系统语音初始化
  },
  beforeDestroy () {
    // 页面销毁的时候暂停语音，清除页面所有定时器
    this.audioList.forEach(item => {
      item.pause()
    })
    clearInterval(this.timer)
    clearInterval(this.getOrderTimer)
  },
  methods: {
    // 初始化数据
    getInitData (type) {
      this.$http.get('/BigScreen', {
        params: {
          OrgCode: this.OrgCode, // 组织id
          CashType: this.CashType, // 处方类别
          DataType: this.DataType // 查询类别
        }
      }).then(data => {
        this.adjusteList = data.data.Dispensing || [] // 待配药列表
        this.medicineList = data.data.Take || [] // 待取药列表
        // eslint-disable-next-line eqeqeq
        this.leftDataEnd = this.adjusteList.length <= 5 ? true : false // 当待配药列表数据小于5条，设置轮询标志默认true
        this.rightDataEnd = this.medicineList.length <= this.DqySilder ? true : false // 当待取药列表数据小于5条，设置轮询标志默认true
        if (this.voiceEnd) {
          if (type === 1) {
          // 第一次请求播报所有并初始化轮播
            this.audioPlayList = data.data.Take || []
            this.audioisPlayList = data.data.Take || []
            this.initSwiper()
          } else {
            // 定时请求数据判断语音是否在播放语音
            let newAudioList = JSON.parse(JSON.stringify(this.medicineList))
            // console.log('新数据列表', JSON.stringify(newAudioList))
            // console.log('已经播放的列表', JSON.stringify(this.audioisPlayList))
            for (let i = newAudioList.length - 1; i >= 0; i--) {
              for (let j = 0; j < this.audioisPlayList.length; j++) {
                // console.log('newAudioList', newAudioList[i].DisSN)
                // console.log('audioisPlayList', this.audioisPlayList[j].DisSN)
                if (newAudioList[i].DisSN === this.audioisPlayList[j].DisSN) {
                  newAudioList.splice(i, 1)
                  break
                }
              }
            }
            // console.log('处理后的需要播放的radios', newAudioList)
            newAudioList.forEach(item => {
              this.audioisPlayList.push(item)
            })
            this.audioPlayList = newAudioList
          }
          this.baiduAuido(this.audioPlayList)
        }
      // eslint-disable-next-line handle-callback-err
      }).catch(err => {
        // alert('网络异常，请检查网络设置!')
      })
    },
    // 播报语音
    baiduAuido (medicineList) {
      if (medicineList.length === 0) return
      this.voiceEnd = false
      this.audioList = []
      let i = -1
      medicineList.forEach(element => {
        // &spd=5 速度
        let url = 'https://tts.baidu.com/text2audio?cuid=baike&lan=ZH&ctp=1&pdt=301&vol=9&per=0&tex=' + encodeURI(element.VoiceInfo)
        this.audioList.push(new Audio(url))
      })
      this.$nextTick(function () {
        playSnd()
      })
      let _this = this
      function playSnd () {
        i++
        if (i === _this.audioList.length) {
          _this.voiceEnd = true
          console.log('语音播报完毕', _this.voiceEnd)
          return
        }
        _this.audioList[i].addEventListener('ended', playSnd)
        _this.audioList[i].play().then(data => {
          console.log('支持audio自动播放')
        // eslint-disable-next-line handle-callback-err
        }).catch(err => {
          console.log('不支持audio自动播放', err)
          if (i === 0) {
            medicineList.forEach((item, index) => {
              _this.speech.speak({text: item.VoiceInfo}).then(() => {
                console.log('播报完成...')
                if (index === medicineList.length) {
                  _this.voiceEnd = true
                }
              })
            })
          }
        })
      }
    },
    // 系统语音初始化
    speechInit () {
      this.speech = new Speech()
      this.speech.setLanguage('zh-CN')
      this.speech.init().then(() => {
        console.log('语音播报初始化完成...')
      })
    },
    // 跳转设置
    goSet () {
      this.$router.push({
        name: 'set',
        params: {

        }
      })
    },
    // 初始化swiper
    initSwiper () {
      let _this = this
      // eslint-disable-next-line no-unused-vars
      // eslint-disable-next-line eqeqeq
      if (_this.DataType == 3 || _this.DataType == 1) {
        // eslint-disable-next-line no-unused-vars
        let mySwiperLeft = new Swiper('#swiperLeft', {
          direction: 'vertical', // 垂直切换选项
          // loop: true, // 循环模式选项
          speed: 1500,
          slidesPerView: 5,
          slidesPerGroup: 5,
          observer: true, // 修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, // 修改swiper的父元素时，自动初始化swiper
          autoplay: {
            delay: 5000
          },
          on: {
            reachBeginning: function () {
              _this.leftDataEnd = true
            }
          }
        })
      }
      if (_this.DataType == 3 || _this.DataType == 2) {
        // eslint-disable-next-line no-unused-vars
        let mySwiperRight = new Swiper('#swiperRight', {
          direction: 'vertical', // 垂直切换选项
          speed: 1500,
          slidesPerView: _this.DqySilder,
          slidesPerGroup: _this.DqySilder,
          observer: true, // 修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, // 修改swiper的父元素时，自动初始化swiper
          autoplay: {
            delay: 5000
          },
          on: {
            reachBeginning: function () {
              // console.log('轮播完了')
              _this.rightDataEnd = true
            }
          }
        })
      }
      // eslint-disable-next-line no-unused-vars
    },
    // 初始化系统时间
    initTime () {
      this.$http.get('/Sys_Date').then(data => {
        let timeMsg = data.data
        this.timeMsg = this.util.formatDate(data.data * 1000, 'yyyy年MM月dd日 hh:mm:ss')
        this.timer = setInterval(() => {
          timeMsg += 1
          this.timeMsg = this.util.formatDate(timeMsg * 1000, 'yyyy年MM月dd日 hh:mm:ss')
        }, 1000)
      })
    }
  }
}
</script>

<style>
@import url('../assets/css/index.css');
</style>



// WEBPACK FOOTER //
// src/pages/display-all.vue